import type { PlanStatus } from '@shared/index';
import { clsx } from 'clsx';

const statusStyles: Record<PlanStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'border-slate-600 bg-slate-800/60 text-slate-200' },
  review: { label: 'In Review', className: 'border-sky-500/40 bg-sky-500/10 text-sky-300' },
  published: { label: 'Published', className: 'border-emerald-500/50 bg-emerald-500/10 text-emerald-300' },
  suspended: { label: 'Suspended', className: 'border-amber-500/50 bg-amber-500/10 text-amber-200' },
  archived: { label: 'Archived', className: 'border-slate-500/60 bg-slate-800/60 text-slate-300' },
};

interface Props {
  status: PlanStatus;
}

const PlanStatusBadge = ({ status }: Props) => {
  const style = statusStyles[status] ?? statusStyles.draft;
  return (
    <span className={clsx('inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium', style.className)}>
      {style.label}
    </span>
  );
};

export default PlanStatusBadge;
